import React from 'react'
import { Table as T } from 'antd'
import { useHandleChangePage, useShouldRedirectToLastPage } from 'src/hooks/useValidateQuerySearch'
import { useTranslation } from 'react-i18next'

export function Table ({ paginatedData, queryData, columns, onChangeSort, disableShowTotal, className, widthTable = 252, ...rest }) {
  const { t } = useTranslation()
  const handleChangePage = useHandleChangePage()
  useShouldRedirectToLastPage(paginatedData)

  const pagination = {
    position: paginatedData?.numberOfElements >= 10 ? ['topRight', 'bottomRight'] : ['topRight'],
    showSizeChanger: true,
    current: paginatedData?.number + 1 || 1,
    total: paginatedData?.totalElements || 0,
    size: 'lager',
    defaultPageSize: queryData.page_size || 10,
    defaultCurrent: 1,
    pageSize: queryData.size,
    showTotal: disableShowTotal ? () => {} : (total, range) => (
      <>
        Showing <strong>{range[0]}</strong> to <strong>{range[1]}</strong> of <strong>{total}</strong> results
      </>
    )
      // `${range[0]}-${range[1]} ${t('common.paginate.of')} ${total} ${t('common.paginate.items')}`
  }
  const onChange = (pagination, filters, sorter, extra) => {
    handleChangePage(pagination, filters, sorter, extra)
    onChangeSort && onChangeSort(sorter)
  }
  return (
    <T
      rowKey='id'
      columns={columns}
      dataSource={paginatedData?.content || []}
      pagination={pagination}
      onChange={onChange}
      size='small'
      className={`${className ||'p-list'} mt-3`}
      style={{ '--pagination-width': `${widthTable}px` }}
      {...rest}
      scroll={{ x: 1200 }}
    />
  )
}
